import { CharacterInfoResponse } from '../../types/character';

export const getCharacterInfoModel = (response: CharacterInfoResponse): CharacterInfoResponse => response;
